<template>
  <div>
    <el-card class="box-card" style="margin:20px">
      <div slot="header">
        <h3 style="margin-bottom:10px">司机列表</h3>
        <el-form :model="queryParams" inline>
          <el-form-item label="司机名称">
            <el-input v-model="queryParams.name" clearable placeholder="请输入" style="width:180px" size="mini" />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="queryParams.mobile" clearable placeholder="请输入" style="width:180px" size="mini" />
            <el-button type="primary" @click="onQuery" size="mini" style="margin-left:10px">查询</el-button>
            <el-button type="success" @click="onAdd" size="mini">新增司机</el-button>
          </el-form-item>
        </el-form>
      </div>

      <plt-table ref="tableRef" :url="queryUrl" :queryParams="queryParams" paramName="param">
        <el-table-column label="司机名称" prop="name" />
        <el-table-column label="手机号" prop="mobile" />
        <el-table-column label="身份证号" prop="identityNo" />
        <el-table-column label="车牌号" prop="plateNo" />
        <plt-table-dict-col label="车辆类型" prop="vehicleId" namespace="logistic" id="vehicleType" />
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button type="primary" @click="onEdit(row)" size="mini">修改</el-button>
            <el-button type="danger" @click="onDelete(row)" size="mini">删除</el-button>
          </template>
        </el-table-column>

      </plt-table>

    </el-card>
    <add-driver ref="addDriverRef" @onFinish="onFinish" />
  </div>
</template>

<script>
import addDriver from "./component/add-driver.vue";
export default {
  components: { addDriver },
  data() {
    return {
      driverList: [],
      queryParams: {
        carrierId: sessionStorage.getItem("memberId")
      },
      queryUrl: "http://CORE-MEMBER/messageService/logisticsDriverService/queryLogisticsDriverDetailParam"
    };
  },
  methods: {
    onAdd() {
      this.$refs["addDriverRef"].openDialog();
    },
    onQuery() {
      this.$refs["tableRef"].loadFirstPage();
    },
    onFinish() {
      this.$refs["tableRef"].queryData();
    },
    onEdit(row) {
      this.$refs["addDriverRef"].openDialog(row);
    },
    onDelete({ carrierId, driverId }) {
      let url = "http://CORE-MEMBER/messageService/logisticsDriverService/unbindLogisticsDriver";
      this.cfmInvoke(url, { carrierId, driverId }, { msg: "确定删除司机吗？" }).then(() => {
        this.$message.success("操作成功");
        this.onQuery();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.warrper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.driver-list {
  font-weight: bold;
  font-size: 18px;
  padding-right: 10px;
}
</style>
